import {
  Component,
  ChangeDetectionStrategy,
  Input,
  ChangeDetectorRef,
  OnInit,
} from '@angular/core';
import { Router } from '@angular/router';
import { weeksBeforeVoucherNAPackageExpireAlertShouldBeShown } from '@common';
import { AuthStore, BookingSubscription, Platform } from '@store';
import { EquipmentApi, SubscriptionPlan, SubscriptionStatus } from '@vi-iot/client/index';
import moment from 'moment';

import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-voucher-booking-tile',
  templateUrl: './voucher-booking-tile.component.html',
  styleUrls: ['./voucher-booking-tile.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VoucherBookingTileComponent implements OnInit {
  @Input() subscription: BookingSubscription;
  @Input() isActiveSubscription: boolean;

  readonly subscriptionStatus = SubscriptionStatus;
  readonly BookingPlans = SubscriptionPlan;
  readonly DEVICE_PLACEHOLDER_IMG_URL = '/assets/img/devices/device_small.png';
  private ngUnsubscribe$: Subject<void> = new Subject<void>();
  deviceImage: string;
  duration: number;
  gatewayPlatformType: Platform;

  constructor(
    public authStore: AuthStore,
    private router: Router,
    private equipmentApi: EquipmentApi,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.getDeviceImage();
    this.duration = this.isActiveSubscription
      ? moment(this.subscription.expirationDate).diff(moment(), 'days')
      : undefined;
  }

  onRenewSubscription(): void {
    let queryParams = {
      boilerSerial: this.subscription.boilerId,
      step: 3,
    };
    this.router.navigate(['/booking'], {
      queryParams,
    });
  }

  private getDeviceImage(): void {
    if (
      this.subscription.deviceImageUrl &&
      this.subscription.deviceImageUrl !== this.DEVICE_PLACEHOLDER_IMG_URL
    ) {
      this.deviceImage = this.subscription.deviceImageUrl;
    } else {
      if (this.subscription.boilerId) {
        this.equipmentApi
          .getDeviceImage(this.subscription.boilerId.substring(0, 7), '70px')
          .pipe(takeUntil(this.ngUnsubscribe$))
          .subscribe((data) => {
            if (data && data.images.length > 0) {
              this.deviceImage = data.images[0].url;
              this.cdr.markForCheck();
            }
          });
      } else {
        this.deviceImage = this.DEVICE_PLACEHOLDER_IMG_URL;
      }
    }
  }

  renewProPackage(subscription: BookingSubscription): boolean {
    return (
      subscription.plan.toString() === SubscriptionPlan.Pro &&
      moment(subscription.expirationDate).isBefore(
        moment().add(weeksBeforeVoucherNAPackageExpireAlertShouldBeShown, 'weeks')
      ) &&
      !subscription.trial &&
      subscription.registeredInstallation &&
      this.isActiveSubscription
    );
  }
}
